// Shared design tokens, terminology and formatters for the Match Tickets module
// (NDS Match Tickets spec §2, §11). Terminology is fixed: the only three result
// labels are "Even", "Forgot Tickets" and "Over Ticket Paid". The neutral/negative
// synonyms the spec bans (§2, §14) must never appear in this module.

export const NAVY = '#0a0e2a';
export const INDIGO = '#4a4fba';
export const INDIGO_LIGHT = '#6d72d6';
export const LAVENDER = '#eef0ff';
export const GREEN = '#059669';
export const RED = '#e11d48';
export const SLATE = '#5b6280';
export const PAGE_BG = '#f4f5f9';
export const CARD_BORDER = '#e9eaf4';

// Dark-card status tints (spec §5.2 / §11).
export const GREEN_TINT = '#6ee7b7';
export const RED_TINT = '#fda4af';

export const STATUS = {
  even: { label: 'Even', color: SLATE, bg: '#eef0f6' },
  forgot_tickets: { label: 'Forgot Tickets', color: GREEN, bg: '#e7f7f0' },
  over_ticket_paid: { label: 'Over Ticket Paid', color: RED, bg: '#fee7ec' },
};

// Amounts always carry two decimals and a thousands separator: $16,300.00.
export const money = (n) => {
  const v = Math.abs(Number(n) || 0);
  return `$${v.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

// Positive => +$20.00, negative => −$50.00 (true minus U+2212), zero => $0.00.
export const signed = (n) => {
  const v = Number(n) || 0;
  if (v === 0) return '$0.00';
  return `${v > 0 ? '+' : '−'}${money(v)}`;
};

// Derive the session net status label from the sign of the net (spec §5.2).
export const netStatusKey = (net) => {
  const v = Number(net) || 0;
  if (v === 0) return 'even';
  return v > 0 ? 'forgot_tickets' : 'over_ticket_paid';
};

// Fallback totals computed client-side from the machine list, used when the
// server session summary is unavailable (older cached payloads). Mirrors §8.4.
export const computeTotals = (differenceList = []) => {
  const num = (x) => Number(x) || 0;
  const readingTotal = differenceList.reduce((a, m) => a + num(m.readingOut), 0);
  const ticketTotal = differenceList.reduce((a, m) => a + num(m.ticketOut), 0);
  const net = readingTotal - ticketTotal;
  const forgotAmount = differenceList
    .filter((m) => num(m.diff) > 0)
    .reduce((a, m) => a + num(m.diff), 0);
  const overAmount = Math.abs(
    differenceList.filter((m) => num(m.diff) < 0).reduce((a, m) => a + num(m.diff), 0)
  );
  const ticketCount = differenceList.reduce((a, m) => a + num(m.ticketCount), 0);
  return {
    readingTotal,
    ticketTotal,
    net,
    forgotAmount,
    overAmount,
    machineCount: differenceList.length,
    ticketCount,
    evenCount: differenceList.filter((m) => m.status === 'even').length,
    forgotCount: differenceList.filter((m) => m.status === 'forgot_tickets').length,
    overCount: differenceList.filter((m) => m.status === 'over_ticket_paid').length,
  };
};
